/**
 * Pure message-content transforms for the chat transcript.
 *
 * Extracted from `AgentChat.tsx` so tests can exercise them without importing
 * a ~2 700-line component. That matters beyond tidiness: the `components`
 * Vitest project runs with `isolate: false` (RFC-0849 Step 8), so pulling
 * AgentChat's whole module graph into a worker to test a string function
 * leaks its providers' background fetches into unrelated files sharing that
 * worker.
 */

/** Matches an RFC-1218 attached-document block, capturing the filename. */
const ATTACHED_DOCUMENT_RE = /<attached-document name="([^"]*)"[^>]*>[\s\S]*?<\/attached-document>/g

/**
 * Strip ```dag-proposal, ```story-structure, ```story-direction code blocks and
 * RFC-1218 attached-document payloads from message content so users don't see
 * raw JSON or a wall of their own document text.
 *
 * The document block is REPLACED (not dropped) with a paperclip line: the text
 * genuinely was part of the turn, so erasing it entirely would leave the
 * transcript claiming the user sent only "adapt this".
 */
export function stripInternalBlocks(content: string): string {
  return content
    .replace(/```dag-proposal[\s\S]*?```/g, '')
    .replace(/```story-structure[\s\S]*?```/g, '')
    .replace(/```story-direction[\s\S]*?```/g, '')
    .replace(ATTACHED_DOCUMENT_RE, (_match, filename: string) => `\u{1F4CE} ${filename}`)
    .trim()
}
